<template>
    <div 
        class="o-p-header"
        :style="componentStyles"
    >
        <div class="o-p-header__title">
            {{title}}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'OPHeader',
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPHeader.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPHeader.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPHeader.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPHeader.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        title() {
            return this.componentParams.title ? this.$t(this.componentParams.title) : this.$t('ui.poster.header-title')
        }
    }
}
</script>

<style lang="scss">
@import "o-p-header";
</style>